import {emitter} from 'dna-core/components/eventemitter';

/* eslint no-unused-expressions: 0 */

/**
 * Class representing a dna input-prefix
 * @classdesc Constructor for a dna input-prefix
 * @param {Object} options.el. Class instance's parent element
 */
export default class InputPrefix {
	constructor(options = {}) {
		this.el = options.el;

		// Cancel instantiation if DOM not as expected
		if (!this.verifyDOM()) {
			emitter.emit('dna.InputPrefix.didCancelInit', {
				emitter: this
			});
			return {};
		}

		this.init();

		// Everything inited as expected
		emitter.emit('dna.InputPrefix.didInit', {
			emitter: this
		});

		return this;
	}
	/**
	 * Verify the required DOM nodes are present
	 * @description Check that the object instance's parent element, and any necessary child nodes, are present in the DOM
	 * @returns {Boolean} Whether all DOM nodes are present or not
	 */
	verifyDOM() {
		let hasVerified = true;
		if (!this.el || !this.el.hasAttribute('data-dna-input-prefix')) {
			hasVerified = false;
		}
		return hasVerified;
	}
	/**
	 * Initialise the class
	 * @description
	 */
	init() {
		this.inputPadding = parseInt(getComputedStyle(this.el).paddingLeft, 10);
		this.wrapInput();
		this.createTokenEl();
		this.appendToken();
		this.setPrefix();
	}
	/**
	 * Create wrapper around input
	 */
	wrapInput() {
		if (!this.el.parentNode.classList.contains('dna-input-prefix')) {
			this.wrapper = document.createElement('span');
			this.wrapper.classList.add('dna-input-prefix');
			this.el.parentNode.insertBefore(this.wrapper, this.el);
			this.wrapper.appendChild(this.el);
		}
	}
	/**
	 * Create element to hold prefix
	 */
	createTokenEl() {
		this.token = document.createElement('span');
		this.token.classList.add('dna-input-prefix-token');
	}
	/**
	 * Append the prefix token to the input wrapper
	 */
	appendToken() {
		this.wrapper.appendChild(this.token);
	}
	setPrefix() {
		this.setTokenLabel();
		this.getPrefixWidth();
		this.setInputPadding();
	}
	/**
	 * Set the text (label) of the prefix token to the data-dna-input-prefix value
	 */
	setTokenLabel() {
		const dataset = this.el.dataset;
		this.token.innerHTML = (dataset && dataset.dnaInputPrefix) ? dataset.dnaInputPrefix : '';
	}
	/**
	 * Get the computed width of the label
	 */
	getPrefixWidth() {
		return this.token.offsetWidth;
	}
	/**
	 * Set padding on the input to account for prefix width plus its own padding
	 */
	setInputPadding() {
		this.el.style.paddingLeft = `${this.inputPadding + this.getPrefixWidth()}px`;
	}
	/**
	 * Reset the prefix label to latest data-dna-input-prefix value
	 */
	updatePrefix() {
		this.setTokenLabel();
		this.setInputPadding();
	}
	/**
	 * Remove nodes and event listeners for cleanup
	 */
	destroy() {
		// Remove token
		const token = this.el.parentNode.querySelector('.dna-input-prefix-token');
		token && this.el.parentNode.removeChild(token);

		// Remove Input wrapper
		const parent = this.el.parentNode.classList.contains('dna-input-prefix') ? this.el.parentNode : null;
		parent && this.el.parentNode.parentNode.removeChild(parent);
	}
}



// WEBPACK FOOTER //
// ../~/dna-form/components/input-prefix/input-prefix.js